import { Component, Input, EventEmitter, Output, ViewChild, AfterViewInit } from '@angular/core';
import * as _ from 'lodash';
import { Paginator } from 'primeng/paginator';


@Component({
  selector: 'mapfre-auditlib-pagination-back',
  templateUrl: './pagination-back.component.html',
  styleUrls: ['./pagination-back.component.scss']
})
export class PaginationBackComponent implements AfterViewInit {
  _itemsPerPage;

  @Input() rowsPerPageOptions = [3, 6, 9];

  @Input() totalElements;

  @Output()
  pageChange = new EventEmitter();

  @Output()
  onChange = new EventEmitter();

  _page = 0;
  @Input()
  get page() {
    return this._page;
  }
  set page(value) {
    if (value !== null && this._page !== value) {
      this._page = value;
      setTimeout(() => {
        this.paginator.changePage(value);
      }, 0)
    }
  }

  @Input()
  get itemsPerPage() {
    return this._itemsPerPage;
  }
  set itemsPerPage(value) {
    if (value) {
      this._itemsPerPage = value;
    }
    else {
      this._itemsPerPage = 3;
    }
  }


  @Output() itemsPerPageChange = new EventEmitter();

  //to paginator
  @ViewChild('p', { static: false }) paginator: Paginator;

  constructor() { }

  ngAfterViewInit() {
    this.paginator.changePage(this.page);
  }

  emitPageChange(event) {
    this._itemsPerPage = event.rows;
    this._page = event.page;
    this.itemsPerPageChange.emit(event.rows);
    this.pageChange.emit(event.page);
    this.onChange.emit(event);
  }
}
